import { useBlockListConfig } from 'hooks/business/useBlockListConfig';
import { useMemo } from 'react';
import { useOfficialReasonList } from '../components/useOfficialReason';

const useReasons = (enable?: boolean) => {
  const config = useBlockListConfig(enable);
  const officialReasons = useOfficialReasonList();
  const reasons = useMemo(() => {
    if (!config) {
      return [];
    }
    const custom = config.customReasons || [];
    return [...officialReasons, ...custom];
  }, [config, officialReasons]);

  return reasons;
};
export default useReasons;
